<template>
  <div>
    <div class="container-perguntas" :id="`pergunta_${pergunta.perguntaId}`" :key="`container_pergunta_${index}`" v-for="(pergunta,index) in perguntas.filter(p=>p.visivel).sort((a,b)=>a.ordemExibicao - b.ordemExibicao)">
       <Pergunta :key="`pergunta_${pergunta.perguntaId}_${index}`" :pergunta="pergunta"  />
    </div>
  </div>
</template>

<script>
import Pergunta from './Pergunta'
export default {
  name: 'comp-perguntas',
  props: ['perguntas'],
  components: { Pergunta }
}
</script>

<style>
.container-perguntas{
  margin-bottom: 1vh;
}
</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/Perguntas.vue